<div class="d-flex justify-content-center align-items-center">
  <output class="spinner-grow text-primary loading-spinner"></output>
  <output class="spinner-grow text-primary loading-spinner"></output>
  <output class="spinner-grow text-primary loading-spinner"></output>
</div>
